import React, { ReactElement } from 'react';
import { css } from '@emotion/react';
import Colors from '../../../types/colors';
import useDpi from '../../../hooks/useDpi';
import { IDashboardDataListItem } from '../../../apis/v1/dashboard.api';
import BarChartLegend from './bar-chart-legend/bar-chart-legend';
import NewBarChart from '../../atoms/chart/bar-chart2';
import { getDefualtLegendList, youngAdultLegendList } from './bar-chart-legend/const';

interface BarChartSectionViewProps {
  icon?: any;
  moreBtn?: ReactElement<any, any>;
  data?: IDashboardDataListItem;
  iconName?: any;
}

const BarChartSectionView = ({ icon, moreBtn, data, iconName }: BarChartSectionViewProps) => {
  const { iconFontSize, secondaryFontSize } = useDpi();
  const wrapperContainer = css`
    display: flex;
    flex-direction: column;
    width: 100%;
    padding: 10px;
    box-sizing: border-box;
  `;
  const wrapper = css`
    display: flex;
    flex-direction: column;
    background-color: ${Colors.white_regular};
    padding: 15px 10px;
    border-radius: 15px;
    width: 100%;
    box-sizing: border-box;
  `;
  const chartWrapper = css`
    display: flex;
    flex-direction: column;
    width: 100%;
    box-sizing: border-box;
    gap: 8px;
  `;
  const iconWrapper = css`
    display: flex;
    justify-content: space-between;
  `;
  const iconStyle = css`
    display: flex;
    align-items: center;
    width: max-content;
    font-size: ${iconFontSize}px;
    font-weight: bold;
    span {
      font-size: ${secondaryFontSize}px;
      /* "유지"와 같이 모든 글자가 한 줄에 모두 나타나도록 개행을 방지하고, 줄이 너무 길 경우 글자 단위로 강제 개행되도록 한다. */
      white-space: pre-line; /* 줄 바꿈 문자(\n)를 개행으로 처리 */
      word-break: keep-all; /* 글자 단위로 줄 바꿈 */
    }
  `;

  const alertText = css`
    color: '#ABABAB';
    font-size: 10px;
    font-weight: 400;
    padding-left: 40px;
  `;

  const currentLegendList = (() => {
    const defaultLegendList = getDefualtLegendList(data?.colorLineInfo);
    if (data?.graphCd) return youngAdultLegendList[data?.graphCd] || defaultLegendList;
    return defaultLegendList;
  })();

  return (
    <div css={wrapperContainer}>
      <div css={wrapper}>
        <div css={chartWrapper}>
          <div css={iconWrapper}>
            <div css={iconStyle}>
              <div>{icon}</div>
              <span>{iconName}</span>
            </div>
            <div>{moreBtn}</div>
          </div>
          <BarChartLegend currentLegendList={currentLegendList} />
          {/* <BarChart BarData={data} /> */}
          <NewBarChart BarData={data} currentLegendList={currentLegendList} />
        </div>
        {data?.alertYn && <span css={alertText}>* 전문가의 상담이 필요함</span>}
      </div>
    </div>
  );
};

export default BarChartSectionView;
